// Espace donateur (/mon-espace) — demande d'accès, inscription, tableau de
// bord (promesses, Cerfas), profil. Clés préfixées "portal.".
// Les libellés transverses (Email, Téléphone, Annuler…) viennent de common.js.
const portal = {
  fr: {
    // ── Écran d'accès / inscription ──
    "portal.title": "Mon espace donateur",
    "portal.subtitle": "Accédez à votre historique de dons et vos reçus fiscaux.",
    "portal.tab_access": "J'ai un compte",
    "portal.tab_register": "Créer mon compte",
    "portal.email_placeholder": "votre@email.com",
    "portal.not_found_email": "Aucun compte trouvé avec cet email.",
    "portal.not_found_phone": "Aucun compte trouvé avec ce numéro.",
    "portal.not_found_hint": "Vous n'avez peut-être pas encore de compte donateur.",
    "portal.create_account_cta": "Créer mon compte →",
    "portal.two_step_note": "Vérification d'identité en 2 étapes — aucun mot de passe à retenir.",
    "portal.multi_org_prefix": "Vous êtes inscrit dans",
    "portal.multi_org_count": "{count} synagogues",
    "portal.multi_org_suffix": "Après confirmation, vous verrez vos dons et reçus de chacune dans des onglets.",
    "portal.verify_access_text": "Pour accéder à votre espace, vérifions votre identité. Nous vous envoyons un email avec un bouton « Oui c'est bien moi » à cliquer.",
    "portal.opening_space": "Ouverture de votre espace…",
    "portal.select_org": "Sélectionnez votre synagogue *",
    "portal.two_step_register_note": "Vérification d'identité en 2 étapes — votre compte sera créé après confirmation.",
    "portal.verify_register_text": "Pour créer votre compte, confirmons que c'est bien vous. Nous vous envoyons un email avec un bouton « Oui c'est bien moi » à cliquer.",
    "portal.back_to_form": "← Retour au formulaire",
    "portal.creating_space": "Création de votre espace…",
    "portal.send_problem_title": "Problème d'envoi",
    // Erreurs accès / inscription
    "portal.err_load_orgs": "Impossible de charger les synagogues.",
    "portal.err_server_unreachable": "Impossible de joindre le serveur.",
    "portal.err_generic_status": "Erreur {status} — réessayez.",
    "portal.err_unexpected": "Réponse inattendue — réessayez.",
    "portal.err_exchange": "Échange impossible — réessayez.",
    "portal.err_register": "Création impossible — réessayez.",
    "portal.err_name_required": "Prénom et nom obligatoires.",
    "portal.err_email_required": "Email obligatoire.",
    "portal.err_org_required": "Veuillez sélectionner votre synagogue.",
    // ── Profil ──
    "portal.profile_title": "Mon profil",
    "portal.edit": "Modifier",
    "portal.save": "Enregistrer",
    "portal.saving": "Enregistrement...",
    "portal.has_company_label": "Je donne (aussi) au nom d'une société",
    "portal.rep_civility": "Civilité du représentant",
    "portal.civility_mr": "M.",
    "portal.civility_mrs": "Mme",
    "portal.rep_first_name": "Prénom du représentant",
    "portal.rep_last_name": "Nom du représentant",
    "portal.company_address_label": "Adresse du siège",
    "portal.address_label": "Adresse (pour vos reçus Cerfa)",
    "portal.address_placeholder": "Commencez à taper l'adresse…",
    "portal.company_note_1": "Cette adresse du siège est",
    "portal.company_note_strong": "indépendante",
    "portal.company_note_2": "de votre adresse personnelle (utilisée pour vos reçus en tant que particulier). Au paiement, vous choisirez « moi-même » ou « ma société ». Le don société donne un reçu Cerfa entreprise (art. 238 bis, 60 %), à cette adresse, représentée par le nom ci-dessus.",
    "portal.field_name": "Nom :",
    "portal.field_phone": "Téléphone :",
    "portal.field_address": "Adresse :",
    "portal.field_company": "Ma société :",
    "portal.add_company": "Ajouter ma société (pour donner à son nom)",
    "portal.missing_info": "⚠️ Informations manquantes : {list}",
    "portal.missing_phone": "téléphone",
    "portal.missing_address": "adresse",
    "portal.profile_updated": "Profil mis à jour !",
    "portal.err_update": "Erreur lors de la mise à jour.",
    "portal.err_network": "Erreur réseau.",
    // ── Tableau de bord ──
    "portal.link_expired": "Lien expiré",
    "portal.err_invalid_link": "Lien invalide ou expiré.",
    "portal.request_new_link": "Demander un nouveau lien",
    "portal.personal_space": "Espace personnel",
    "portal.hello": "Chalom, {name}",
    "portal.all_orgs": "Toutes les synagogues",
    "portal.stat_total": "Total donné",
    "portal.stat_pledges": "Dons enregistrés",
    "portal.stat_cerfas": "Reçus Cerfa",
    "portal.new_donation_title": "Faire un nouveau don",
    "portal.new_donation_sub": "Montant libre · reçu fiscal Cerfa automatique",
    "portal.donate": "Faire un don",
    "portal.donate_to": "Donner à {name}",
    "portal.cerfa_title": "Reçus fiscaux (Cerfa)",
    "portal.cerfa_sub": "Téléchargez vos reçus pour votre déclaration d'impôts",
    "portal.cerfa_empty": "Aucun reçu fiscal disponible.",
    "portal.err_download": "Téléchargement impossible.",
    "portal.pledges_title": "Historique des dons",
    "portal.pledges_empty": "Aucun don enregistré.",
    "portal.pay_button": "Payer",
    "portal.err_pay_link": "Impossible de générer le lien de paiement.",
    "portal.status_pending": "En attente",
    "portal.status_partial": "Partiel",
    "portal.status_paid": "Payé",
    "portal.status_cancelled": "Annulé",
    // ── Modale « payer en tant que » ──
    "portal.pay_as_title": "Vous payez en tant que ?",
    "portal.pay_as_sub": "Cela détermine votre reçu fiscal (Cerfa).",
    "portal.pay_as_self": "Moi-même",
    "portal.pay_as_self_sub": "{name} · particulier (66 %)",
    "portal.pay_as_company": "Ma société",
    "portal.pay_as_company_sub": "{name} · entreprise (article 238 bis, 60 %)",
  },
  en: {
    // ── Access / registration screen ──
    "portal.title": "My donor portal",
    "portal.subtitle": "Access your donation history and tax receipts.",
    "portal.tab_access": "I have an account",
    "portal.tab_register": "Create my account",
    "portal.email_placeholder": "your@email.com",
    "portal.not_found_email": "No account found with this email.",
    "portal.not_found_phone": "No account found with this number.",
    "portal.not_found_hint": "You may not have a donor account yet.",
    "portal.create_account_cta": "Create my account →",
    "portal.two_step_note": "Two-step identity verification — no password to remember.",
    "portal.multi_org_prefix": "You are registered with",
    "portal.multi_org_count": "{count} synagogues",
    "portal.multi_org_suffix": "After confirming, you'll see your donations and receipts for each one in tabs.",
    "portal.verify_access_text": "To access your portal, let's verify your identity. We'll send you an email with a \"Yes, it's me\" button to click.",
    "portal.opening_space": "Opening your portal…",
    "portal.select_org": "Select your synagogue *",
    "portal.two_step_register_note": "Two-step identity verification — your account will be created once confirmed.",
    "portal.verify_register_text": "To create your account, let's confirm it's really you. We'll send you an email with a \"Yes, it's me\" button to click.",
    "portal.back_to_form": "← Back to the form",
    "portal.creating_space": "Creating your portal…",
    "portal.send_problem_title": "Sending issue",
    // Access / registration errors
    "portal.err_load_orgs": "Unable to load the synagogues.",
    "portal.err_server_unreachable": "Unable to reach the server.",
    "portal.err_generic_status": "Error {status} — please try again.",
    "portal.err_unexpected": "Unexpected response — please try again.",
    "portal.err_exchange": "Verification failed — please try again.",
    "portal.err_register": "Account creation failed — please try again.",
    "portal.err_name_required": "First and last name are required.",
    "portal.err_email_required": "Email is required.",
    "portal.err_org_required": "Please select your synagogue.",
    // ── Profile ──
    "portal.profile_title": "My profile",
    "portal.edit": "Edit",
    "portal.save": "Save",
    "portal.saving": "Saving...",
    "portal.has_company_label": "I (also) give on behalf of a company",
    "portal.rep_civility": "Representative's title",
    "portal.civility_mr": "Mr",
    "portal.civility_mrs": "Mrs",
    "portal.rep_first_name": "Representative's first name",
    "portal.rep_last_name": "Representative's last name",
    "portal.company_address_label": "Head office address",
    "portal.address_label": "Address (for your Cerfa tax receipts)",
    "portal.address_placeholder": "Start typing the address…",
    "portal.company_note_1": "This head office address is",
    "portal.company_note_strong": "independent",
    "portal.company_note_2": "of your personal address (used for your receipts as an individual). At payment time, you'll choose \"myself\" or \"my company\". A company donation issues a corporate Cerfa (French tax receipt — art. 238 bis, 60%), at this address, represented by the name above.",
    "portal.field_name": "Name:",
    "portal.field_phone": "Phone:",
    "portal.field_address": "Address:",
    "portal.field_company": "My company:",
    "portal.add_company": "Add my company (to give in its name)",
    "portal.missing_info": "⚠️ Missing information: {list}",
    "portal.missing_phone": "phone",
    "portal.missing_address": "address",
    "portal.profile_updated": "Profile updated!",
    "portal.err_update": "Update failed.",
    "portal.err_network": "Network error.",
    // ── Dashboard ──
    "portal.link_expired": "Link expired",
    "portal.err_invalid_link": "Invalid or expired link.",
    "portal.request_new_link": "Request a new link",
    "portal.personal_space": "Donor portal",
    "portal.hello": "Shalom, {name}",
    "portal.all_orgs": "All synagogues",
    "portal.stat_total": "Total given",
    "portal.stat_pledges": "Recorded donations",
    "portal.stat_cerfas": "Cerfa receipts",
    "portal.new_donation_title": "Make a new donation",
    "portal.new_donation_sub": "Any amount · automatic Cerfa tax receipt",
    "portal.donate": "Donate",
    "portal.donate_to": "Give to {name}",
    "portal.cerfa_title": "Tax receipts (Cerfa)",
    "portal.cerfa_sub": "Download your receipts for your tax return",
    "portal.cerfa_empty": "No tax receipt available yet.",
    "portal.err_download": "Download failed.",
    "portal.pledges_title": "Donation history",
    "portal.pledges_empty": "No donation recorded yet.",
    "portal.pay_button": "Pay",
    "portal.err_pay_link": "Unable to generate the payment link.",
    "portal.status_pending": "Pending",
    "portal.status_partial": "Partial",
    "portal.status_paid": "Paid",
    "portal.status_cancelled": "Cancelled",
    // ── "Pay as" modal ──
    "portal.pay_as_title": "Who are you paying as?",
    "portal.pay_as_sub": "This determines your tax receipt (Cerfa).",
    "portal.pay_as_self": "Myself",
    "portal.pay_as_self_sub": "{name} · individual (66%)",
    "portal.pay_as_company": "My company",
    "portal.pay_as_company_sub": "{name} · company (article 238 bis, 60%)",
  },
};

export default portal;
